import styled from 'styled-components';
import { theme } from 'styles';

export const CustomLargeModal = styled.div`
  width: 700px; /* 기존 모달보다 넓은 width 설정 */
  height: 600px; /* 기존 모달보다 높은 height 설정 */
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2); /* 그림자 추가 */
  z-index: 12; /* 모달이 화면의 맨 앞에 오도록 설정 */

  .title {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    padding: 17px 16px 16px;
    border-bottom: 1px solid ${theme.colors.gray100};
  }

  .con {
    padding: 24px;
  }

  .btn {
    display: flex;
    padding-top: 32px;
    gap: 8px;
    justify-content: flex-end; /* 변경: 버튼들을 한쪽 끝으로 정렬 */
    padding: 0 24px 24px; /* 좌우 패딩 추가, 아래 패딩 추가 */

    & > button {
      width: 100px;
      height: 40px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      font-size: 16px;
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }

    & > button.cancel {
      background-color: #F4F7FA;
      color: rgba(23, 23, 23, 0.7);
    }
    .cancel:hover {
      background-color: #EFF2F5;
      color: rgba(23, 23, 23, 0.7);
    }

    & > button.confirm {
      background-color: #009592;
      color: #ffffff;
    }
    .confirm:hover {
      background-color: #00B1B2;
      color: #ffffff;
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11; /* 오버레이가 모달 뒤에 오도록 설정 */
`;
export default CustomLargeModal;